/** Turn Supabase / PostgREST errors into readable UI text (never `[object Object]`). */
export function formatSupabaseError(err: unknown): string {
  if (err == null) return "Unknown error";
  if (typeof err === "string") return err;
  if (err instanceof Error && err.message) return err.message;

  if (typeof err === "object") {
    const e = err as Record<string, unknown>;
    const message = typeof e.message === "string" ? e.message : null;
    const details = typeof e.details === "string" ? e.details : null;
    const hint = typeof e.hint === "string" ? e.hint : null;
    const code = typeof e.code === "string" ? e.code : null;
    const parts = [message, details, hint, code ? `(${code})` : null].filter(
      Boolean
    );
    if (parts.length) return parts.join(" — ");
    try {
      return JSON.stringify(err);
    } catch {
      /* fall through */
    }
  }

  return String(err);
}
